// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header__title-3AE8w";
var _3 = "header__price-6pI6O";
export { _1 as "__esModule", _2 as "header__title", _3 as "header__price" }
export default { "__esModule": _1, "header__title": _2, "header__price": _3 }
